import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RecordingBar } from './components/RecordingBar';
import Button from '../../../../../../newComponents/Button';
import { getRegion } from './.././../../../../../utils/Region';
import { getTranslation } from './.././../../../../../utils/getTranslation';
import { isNodeMyContent } from '../../../../../../utils/Utils';
import {
  setShowContainerRecordingBar,
  setDataTime,
} from './redux/recordingsBar.actions';
import './styles.scss';

export const ContainerRecordingBar = ({ cmsCurrentNode }) => {
  const { timeUsed, totalTime } = useSelector(state => state?.recordingsBar);
  const { navData } = useSelector(state => state?.cvNavData);
  const { code: codeMenu } = navData?.selected;
  const cmsNodes = useSelector(state => state?.cvCMS?.cmsNodes);
  const linealChannelData = useSelector(state => state?.linealChannel?.data);
  const translations = useSelector(
    state =>
      JSON.parse(state?.metadata?.translations || '{}')?.language?.[
        getRegion()
      ],
  );

  const dispatch = useDispatch();

  const [availableTime, setAvailableTime] = useState(0);
  const [totalTimeLocal, setTotalTimeLocal] = useState(0);
  const [showContainer, setShowContainer] = useState(false);
  const [progresBar, setProgresBar] = useState(0);
  const [myRecording, setmyRecording] = useState([]);
  const [toRecord, setToRecord] = useState([]);

  //icono de canal caido (warning)
  const { fallenChannel_access_icon_alert_exit } = useSelector(
    state => state?.asset,
  );

  const MYCONTENT_RECORDINGSPACE_AVAILABLE_LABEL = getTranslation(
    'myContent_recordingSpace_available_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_FROM_LABEL = getTranslation(
    'myContent_recordingSpace_from_label',
    translations,
  );
  const MYCONTENT_RECORDINGSPACE_TO_LABEL = getTranslation(
    'myContent_recordingSpace_to_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_WARNING_LABEL = getTranslation(
    'myContent_recordingSpace_warning_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_USED_LABEL = getTranslation(
    'myContent_recordingSpace_used_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_FREE_LABEL = getTranslation(
    'myContent_recordingSpace_free_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_OFFER_LABEL = getTranslation(
    'myContent_recordingSpace_offer_label',
    translations,
  );

  const MYCONTENT_RECORDINGSPACE_OPTION_BUTTON_OFFER = getTranslation(
    'myContent_recordingSpace_option_button_offer',
    translations,
  );

  const URL_MY_RECORDINGS = 'status=3';
  const URL_TO_RECORD = 'status=4';
  const RECORDING_TYPE = 'recording';

  //obtiene el carrusel de mis grabaciones
  const getCarouselMyRecording = () => {
    const carousels = cmsNodes?.[cmsCurrentNode]?.carousels;
    const myRecording = carousels?.find(
      carousel => {
        return carousel?.component?.properties?.url?.includes(URL_MY_RECORDINGS) &&
        carousel?.component?.properties?.type === RECORDING_TYPE;
      }
        
    );
    return myRecording?.contentsList || [];
  };

  //obtiene el carrusel de por grabar
  const getCarouselTorecord = () => {
    const carousels = cmsNodes?.[cmsCurrentNode]?.carousels;
    const toRecord = carousels?.find(carousel => {
      return  carousel?.component?.properties?.url?.includes(URL_TO_RECORD) &&
      carousel?.component?.properties?.type === RECORDING_TYPE;
    });
    return toRecord?.contentsList || [];
  };

  // si existe elementos en el carrusel de grabaciones se muestra el componente
  const getValueShowContainer = (
    myRecordingCarrousel,
    toRecordingCarrousel,
  ) => {
    try {
      if (
        myRecordingCarrousel?.length <= 0 &&
        toRecordingCarrousel?.length <= 0
      ) {
        setShowContainer(false);
        return; // este es para que no siga con el flujo si no hay datos en el carrusel
      }

      //comvierto el obj linealChannelData del store a array
      const arrayLinealChannelData = Object.values(linealChannelData);
      const npvrPakageActive = arrayLinealChannelData?.filter(
        pakage => pakage?.npvr?.value > 0,
      );

      // si existen paquetes activos se muestra el componente
      if (npvrPakageActive?.length > 0) {
        setShowContainer(true);
        return; // este es para que no siga con el flujo
      }
      setShowContainer(false);
    } catch (error) {
      console.warn('===> getValueShowContainer ', error);
      setShowContainer(false);
    }
  };

  // GLOBAL
  const getValueTotalTime = (linealChannelData, group_id) => {
    const groupPackages = linealChannelData?.[`${group_id}`];
    return groupPackages?.npvr?.value;
  };

  const getValueTotalTimeLocal = (myRecording, toRecord, timeUsedValue) => {
    let totalTimeLocalValue = totalTime;
    // si es null es por que no se a selecionado un poster de grabaciones
    // a si que se obtiene por defecto los datos del primer elemento que se encuentre en el carrusel de mis grabaciones
    if (totalTime === null) {
      // carga el primer elemento de mis grabaciones y si no exite
      // cargar el primer elemento de por grabar
      const dataCorousel = myRecording?.length
        ? myRecording?.[0]
        : toRecord?.[0];
      const dataPoster = dataCorousel;
      const npvr = getValueTotalTime(
        linealChannelData,
        dataPoster?.channel?.group_id,
      );
      totalTimeLocalValue = npvr;

      // si es undefined es por que no se encontro el group_id en algun paquete de linealChannelData;
      // asi que el tiempo total es el tiempo ya utilizado
      if (npvr === undefined) {
        totalTimeLocalValue = timeUsedValue;
      }
    }
    // si es undefined es por que no se encontro el group_id en algun paquete de linealChannelData;
    // asi que el tiempo total es el tiempo ya utilizado
    if (totalTime === undefined) {
      totalTimeLocalValue = timeUsedValue;
    }

    const resTotal = Number(totalTimeLocalValue || '');

    setTotalTimeLocal(resTotal);
    return resTotal;
  };

  // global
  const getValueTimeUsed = (time_used, pack_id) => {
    // obtengo el tiempo del enpoint (en segundos)
    const timeUsedInSeconds = time_used?.[`pack_${pack_id}`] || 0;
    const timeUsedInHrs = timeUsedInSeconds / (60 * 60); // los combierto a horas
    const timeUsedInHrsString = timeUsedInHrs?.toFixed(1) || ''; // redondeo a un decimal
    return Number(timeUsedInHrsString);
  };

  // valida cual debe ser el valor de timeUsed ((local))
  const getValueTimeUsedLocal = () => {
    // si timeUse es null, se debe de cargar los datos del primer elemento
    // que se encuentra en el carrusel
    if (timeUsed === null) {
      const dataCarousel = myRecording?.length
        ? myRecording?.[0]
        : toRecord?.[0];
      const { time_used, pack_id } = dataCarousel || {};
      return getValueTimeUsed(time_used, pack_id);
    }
    // si desde el endpoint se manda el dato, se utiliza ese mismo
    if (timeUsed) return timeUsed;
    // si es undefined se retorna 0
    return 0;
  };

  //si exite un tiempo total realiza el calculo, si no existe es por que no encontro el
  const getAvailableTime = (totalTimeLocalValue, timeUsedValue) => {
    let availableTimeValue = 0;
    if (timeUsedValue <= totalTimeLocalValue) {
      availableTimeValue = totalTimeLocalValue - timeUsedValue;
    }
    // Y SI EL TIEMPO LIBRE ES MAYOR AL TIEMPO TOTAL ??
    setAvailableTime(availableTimeValue);
  };

  const getProgreBar = (totalTimeLocalValue, timeUsedLocal) => {
    const porcentage = (timeUsedLocal * 100) / totalTimeLocalValue;
    setProgresBar(porcentage);
  };

  const isFullUsed = () => progresBar >= 100;

  const textRecordingSpaceAvailable = () => {
    const hrs = `${availableTime}${MYCONTENT_RECORDINGSPACE_FROM_LABEL} ${totalTimeLocal}${MYCONTENT_RECORDINGSPACE_TO_LABEL}`;
    const recordingSpaceAvailable = `${MYCONTENT_RECORDINGSPACE_AVAILABLE_LABEL} ${hrs}`;
    return recordingSpaceAvailable;
  };

  const handleClick = () => {
    console.log('Clikc');
  };

  useEffect(
    () => {
      if (isNodeMyContent(codeMenu)) {
        const myRecordingCarrousel = getCarouselMyRecording();
        const toRecordingCarrousel = getCarouselTorecord();
        setmyRecording(myRecordingCarrousel);
        setToRecord(toRecordingCarrousel);
        getValueShowContainer(myRecordingCarrousel, toRecordingCarrousel);
      }
    },
    [codeMenu, cmsNodes?.[cmsCurrentNode]?.carousels],
  );

  useEffect(
    () => {
      if (showContainer) {
        const timeUsedValue = getValueTimeUsedLocal();
        const totalTimeLocalValue = getValueTotalTimeLocal(
          myRecording,
          toRecord,
          timeUsedValue,
        );
        getAvailableTime(totalTimeLocalValue, timeUsedValue);
        getProgreBar(totalTimeLocalValue, timeUsedValue);
      } else {
        dispatch(
          setDataTime({
            timeUsed: null,
            totalTime: null,
          }),
        );
      }
    },
    [showContainer, myRecording, toRecord, timeUsed, totalTime],
  );

  useEffect(
    () => {
      dispatch(setShowContainerRecordingBar({ show: showContainer }));
    },
    [showContainer],
  );

  return (
    <>
      {isNodeMyContent(codeMenu) && showContainer ? (
        <div className="container-recording-bar">
          <section className="container-recording-bar__bar">
            <div className="bar__info">
              <p>{textRecordingSpaceAvailable()}</p>
              {isFullUsed() && (
                <div className="info__alert">
                  <img
                    className="alert__img"
                    src={fallenChannel_access_icon_alert_exit}
                    alt="alert"
                  />
                  <p>{MYCONTENT_RECORDINGSPACE_WARNING_LABEL}</p>
                </div>
              )}
            </div>
            <RecordingBar progress={progresBar} />
            <div className="bar__indicator">
              <div className="indicator__square">
                <div className="square__red" />
                <p>{MYCONTENT_RECORDINGSPACE_USED_LABEL}</p>
              </div>

              <div className="indicator__square">
                <div className="square__grey" />
                <p>{MYCONTENT_RECORDINGSPACE_FREE_LABEL}</p>
              </div>
            </div>
          </section>

          <section className="container-recording-bar__control">
            {/* <p className="control__ask">
              {MYCONTENT_RECORDINGSPACE_OFFER_LABEL}
            </p>
            <Button onClick={handleClick} classes={['btn-obtener-grabacion']}>
              {MYCONTENT_RECORDINGSPACE_OPTION_BUTTON_OFFER}
            </Button> */}
          </section>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
